import styled from "styled-components";

export const LoginUsernameStyled = styled.div`
  padding: 24px;
  border-radius: 18px;
  background-color: #f6f7f9;

  max-height: 612px;
  min-width: 550px;
  margin-top: 42px;

  .input--custom {
    width: 47%;
  }
`;
